import { render, staticRenderFns } from "./DesignPortal.vue?vue&type=template&id=1c1f3b91&"
import script from "./DesignPortal.vue?vue&type=script&lang=js&"
export * from "./DesignPortal.vue?vue&type=script&lang=js&"
import style0 from "./DesignPortal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports